import { TypedDocumentNode } from "@graphql-typed-document-node/core/typings";
import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  SearchOrganisationsQuery,
  SearchOrganisationsRequest,
  SearchOrganisationsViaOsQuery,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlInfiniteQuery, useGraphQlQuery } from "../useGraphQlClient";

// TODO: Rename to just useOrganisations once the db org search is removed!
// TODO: May also need to rejig how the existing useOrganisations hook is used
const organisationsQueryViaOs: TypedDocumentNode<
  SearchOrganisationsQuery,
  { request: SearchOrganisationsRequest }
> = graphql(`
  query searchOrganisationsViaOs($request: SearchOrganisationsRequest!) {
    searchOrganisations(SearchOrganisationsRequest: $request) {
      orgs {
        id
        name
        primaryRole
        noticeCount
        address
        town
        countryCode
        categoryAssignments {
          categoryId
          categoryName
          source
        }
        oscarTown
      }
      total
    }
  }
`);

type SearchOrganisationsViaOsResponse = SearchOrganisationsViaOsQuery["searchOrganisations"];
export type OrgBasicInfo = SearchOrganisationsViaOsResponse["orgs"][0];

export function useOrganisationsViaOs(
  searchOrgsRequest: SearchOrganisationsRequest,
  options?: UseQueryOptions<
    SearchOrganisationsViaOsQuery,
    unknown,
    SearchOrganisationsViaOsQuery,
    QueryKey
  >,
) {
  return useGraphQlQuery<SearchOrganisationsViaOsQuery, { request: SearchOrganisationsRequest }>(
    ["searchOrganisations", searchOrgsRequest],
    organisationsQueryViaOs,
    [
      {
        request: searchOrgsRequest,
      },
    ],
    {
      ...options,
    },
  );
}

export type UseSearchOrganisationsViaOsResult = ReturnType<typeof useOrganisationsViaOs>;

// TODO-3245: Do we need this here? copied from db org search hook. What is this doing?
export function useInfiniteOrganisationsViaOs(searchOrgsRequest: SearchOrganisationsRequest) {
  return useGraphQlInfiniteQuery<
    SearchOrganisationsViaOsQuery,
    { request: SearchOrganisationsRequest }
  >(
    ["organisations", searchOrgsRequest],
    organisationsQueryViaOs,
    (page) => [{ request: { ...searchOrgsRequest, page }, useOpensearch: true }],
    {
      getNextPageParam: (lastPage, allPages) => {
        const totalSuppliers = lastPage.searchOrganisations.total;
        const totalLoadedSuppliers = allPages.reduce(
          (acc, page) => acc + page.searchOrganisations.orgs.length,
          0,
        );
        return totalSuppliers > totalLoadedSuppliers ? allPages.length + 1 : undefined;
      },
      getPreviousPageParam: (_, allPages) => allPages.length - 1 || 1,
    },
  );
}
